// The dashboard's period control: one month at a time, or all time. Deliberately
// just three buttons — every extra control on a dashboard is one more thing to
// misread — so there is no free date range and no jump-to-month field.
//
// The month stepper itself is components/MonthStepper, shared with the settlement
// screen's monthly collection card. What stays here is the all-time toggle, which only
// this screen has: the settlement screen's months sit above a cumulative gap that is
// already the all-time view, so a second "all time" there would name the card below it.
import he from '../../i18n/he';
import Button from '../../components/Button';
import MonthStepper from '../../components/MonthStepper';
import { currentMonthStr } from '../../utils/dates';

export default function PeriodPicker({ period, onChange }) {
  const isAll = period.mode === 'all';
  const month = period.month || currentMonthStr();

  return (
    <div className="period-picker">
      {isAll ? (
        <strong className="period-label">{he.dashboard.allTimeLabel}</strong>
      ) : (
        <MonthStepper
          month={month}
          onChange={(m) => onChange({ mode: 'month', month: m })}
          prevLabel={he.dashboard.prevMonth}
          nextLabel={he.dashboard.nextMonth}
        />
      )}
      <Button
        small
        variant={isAll ? 'subtle' : 'ghost'}
        onClick={() => onChange(isAll ? { mode: 'month', month: currentMonthStr() } : { mode: 'all' })}
      >
        {isAll ? he.dashboard.thisMonth : he.dashboard.allTime}
      </Button>
    </div>
  );
}
